import {getErrorMessage} from '@core/utils/api/errorMessage';

const companyColumns = [
    // DS 표 규칙: No. → 메인(상세 링크) → 데이터 → 상세 아이콘. 행 44 고정이라 긴 값은 줄이고 title 로 전체를 보인다
    {
        key: 'no',
        label: 'No.',
        thClass: ['ds-cell-no'],
        tdClass: ['ds-cell-no'],
    },
    {
        key: 'company_name',
        label: '기업명',
        sortable: true,
    },
    {
        key: 'id',
        label: '기업 ID',
        sortable: true,
        thStyle: {width: '120px'},
        thClass: ['text-right'],
        tdClass: ['ds-cell-num'],
    },
    {
        key: 'company_code',
        label: '기업 코드',
        sortable: true,
        thStyle: {width: '200px'},
    },
    {
        key: 'country',
        label: '국가',
        sortable: true,
        thStyle: {width: '120px'},
    },
    {
        key: 'detail',
        label: '',
        thStyle: {width: '64px'},
        tdClass: ['text-right'],
    },
];
// 사용자 레벨(is_admin) 표시명 — 사용자 관리/소속 유저/사용자 수정 화면 공용
const userLevelNames = {1: '일반 사용자', 2: '외부 평가자', 3: '캠페인 평가자', 4: '최고 관리자'};
const getUserLevelLabel = (level) => userLevelNames[level] ? `lv ${level} (${userLevelNames[level]})` : `lv ${level ?? '-'}`;

// 평가 참여자 API 오류 코드(평문 본문) -> 관리자용 문구 — 참여자 관리·참여 등록 모달 공용
const MEMBER_ERROR_MESSAGES = {
    Not_Found_Campaign: '해당 기업과 관련없는 캠페인입니다.',
    Not_Found_Company: '존재하지 않는 기업입니다.',
    Not_Found_Request: '존재하지 않는 평가 신청 건입니다.',
    Not_Found_Users: '존재하지 않는 사용자입니다.',
    Not_Found_User: '존재하지 않는 사용자입니다.',
    Invalid_Request: '올바르지 않은 요청입니다.',
    Invalid_AccessStatus: '유효하지 않은 참여 상태입니다.',
    Not_Joined_User: '평가에 참여하지 않은 사용자입니다.',
    Not_Found_Manager: '기업 평가 관리자가 조회되지 않습니다.',
    UnAuthorized_Request: '관리자 변경을 요청할 권한이 없는 평가 참여자입니다.',
};
const getMemberErrorText = (error, fallback) => {
    const code = getErrorMessage(error, '');
    return MEMBER_ERROR_MESSAGES[code] || (code ? `${fallback} (${code})` : fallback);
};

// assessment.common.mixin getProgressStatus 의 한 글자 약어 -> 배지에 보일 전체 이름 (평가 관리 화면 상태 이름과 같게)
const PROGRESS_STATUS_LABELS = {
    '미': '미신청', '신': '평가신청', '답': '답변중', '보': '보완요청',
    '평': '평가중', '완': '평가완료', '취': '평가취소', '에': '에코바디스',
};

export {
    companyColumns,
    userLevelNames, getUserLevelLabel, getMemberErrorText, PROGRESS_STATUS_LABELS
};
